import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import noImage from '../../assets/images/no-image.svg';
import noImageDark from '../../assets/images/no-image-dark.svg';

class NoImage extends Component {
  render() {
    const src = this.props.isLightThemeActive ? noImage : noImageDark;
    return <img src={src} width={this.props.size} height={this.props.size} alt="" />;
  }
}

NoImage.propTypes = {
  size: PropTypes.number,
  isLightThemeActive: PropTypes.bool.isRequired,
};

NoImage.defaultProps = {
  size: 100,
};

function mapStateToProps(state) {
  return {
    isLightThemeActive: state.userReducer.isLightThemeActive,
  };
}

export default connect(mapStateToProps, null)(NoImage);
